import { resolvePatientName } from '@/features/sessions/components/session-list/patient-cell.utils';
import { getSessionListSummary, type SessionListItem } from '@heidi/session/contracts';
import type { IntlShape } from 'react-intl';
import { navV3Messages } from '../nav-v3.messages';

export interface RecentVisitLabelParts {
  /** Session name, or untitled fallback — never a timestamp. */
  primary: string;
  /** Resolved patient name for the avatar marker, when available. */
  patientName: string | undefined;
}

/**
 * Prefers the editable `session_gist` over the generation-time `session_name`
 * skipping the bookkeeping placeholders on both, then the untitled label.
 */
export function getRecentVisitPrimaryLabel(
  session: Pick<SessionListItem, 'session_name' | 'session_gist'>,
  intl: IntlShape
): string {
  return (
    getSessionListSummary(session) ?? intl.formatMessage(navV3Messages.untitledSession)
  );
}

/**
 * Computes the label `RecentVisitRow` uses for its top-level text and the
 * patient-backed type marker.
 */
export function getRecentVisitLabelParts(
  session: SessionListItem,
  intl: IntlShape
): RecentVisitLabelParts {
  const patientName = resolvePatientName(session);
  const primary = getRecentVisitPrimaryLabel(session, intl);

  return { primary, patientName };
}
